import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const nameMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  category: '视频分类',
  article: '文章详情',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  segments.forEach((seg, index) => {
    const path = '/' + segments.slice(0, index + 1).join('/');
    const label = nameMap[seg] || decodeURIComponent(seg);
    items.push({ label, path: index < segments.length - 1 ? path : undefined });
  });

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-100/70">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.label,
            item: item.path ? `https://www.moguvideo.com${item.path}` : undefined,
          })),
        })}
      </script>
    </nav>
  );
}